module.exports = __webpack_public_path__ + "/static/assets/4c5b75c306a0bd0facfe31074e251c00.gif";